import { getAuth, onAuthStateChanged } from 'firebase/auth';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { isCustomClaimContent } from '../../api/firestoreTypes';
import * as AuthActions from '../../redux/actions/authActions';
import { app } from '../..';

interface AuthStateListenerProps {}
const AuthStateListener: React.FC<AuthStateListenerProps> = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    onAuthStateChanged(getAuth(app), user => {
      dispatch(AuthActions.setUser({ user }));
      user?.getIdTokenResult(true).then(result => {
        const claimContent = result.claims;
        if (!isCustomClaimContent(claimContent)) return;
        dispatch(
          AuthActions.setUserCustomClaim({
            claimContent,
          })
        );
      });
    });
  }, [dispatch]);

  return null;
};
export default AuthStateListener;
